import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/globals.css';
import Navbar from '../components/global/Navbar';
import Hero from '../components/home/Hero';
import Editorial from '../components/home/Editorial';
import Stats from '../components/home/Stats';
import FeaturedProducts from '../components/home/FeaturedProducts';
import Testimonials from '../components/home/Testimonials';
import FAQ from '../components/home/FAQ';

export default function Home() {
  return (
    <>
      <Helmet>
        {/* ── Core ── */}
        <title>SA Dropped | Fresh Sneakers Delivered Across South Africa</title>
        <meta name="description" content="SA Dropped is South Africa's premier sneaker destination. Shop verified Nike, Adidas, Jordan, New Balance and more. 100% authentic, shipped nationwide from Durban." />
        <meta name="keywords" content="sneakers South Africa, buy sneakers SA, Nike South Africa, Adidas South Africa, Jordan South Africa, authentic sneakers, SA Dropped, Durban sneakers, streetwear SA, sneaker store South Africa, Air Force 1 SA, Dunk Low SA, Yeezy SA, New Balance SA" />
        <meta name="author" content="SA Dropped" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.sadropped.co.za" />

        {/* ── Open Graph ── */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SA Dropped" />
        <meta property="og:title" content="SA Dropped | Fresh Sneakers Delivered Across South Africa" />
        <meta property="og:description" content="South Africa's freshest sneaker destination. Shop verified kicks from Nike, Adidas, Jordan and more. Authentic pairs shipped nationwide from Durban." />
        <meta property="og:url" content="https://www.sadropped.co.za" />
        <meta property="og:image" content="https://www.sadropped.co.za/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="SA Dropped — Fresh Sneakers Delivered Across South Africa" />
        <meta property="og:locale" content="en_ZA" />

        {/* ── Twitter ── */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@sa_dropped" />
        <meta name="twitter:creator" content="@sa_dropped" />
        <meta name="twitter:title" content="SA Dropped | Fresh Sneakers Delivered Across South Africa" />
        <meta name="twitter:description" content="South Africa's freshest sneaker destination. Verified Nike, Adidas, Jordan and more. Shipped nationwide." />
        <meta name="twitter:image" content="https://www.sadropped.co.za/og-image.jpg" />
        <meta name="twitter:image:alt" content="SA Dropped Sneakers" />

        {/* ── Geo ── */}
        <meta name="geo.region" content="ZA-KZN" />
        <meta name="geo.placename" content="Durban, KwaZulu-Natal, South Africa" />

        {/* ── Schema.org JSON-LD ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Store",
            "name": "SA Dropped",
            "description": "South Africa's premier sneaker destination. Verified authentic kicks from Nike, Adidas, Jordan and more, shipped nationwide.",
            "url": "https://www.sadropped.co.za",
            "logo": "https://www.sadropped.co.za/logo_nav.png",
            "image": "https://www.sadropped.co.za/og-image.jpg",
            "telephone": "",
            "email": "",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Durban",
              "addressRegion": "KwaZulu-Natal",
              "addressCountry": "ZA"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "-29.8587",
              "longitude": "31.0218"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
              ],
              "opens": "09:00",
              "closes": "18:00"
            },
            "sameAs": [
              "https://www.instagram.com/sa_dropped"
            ],
            "priceRange": "R500 - R10000",
            "currenciesAccepted": "ZAR",
            "paymentAccepted": "EFT, Cash",
            "areaServed": {
              "@type": "Country",
              "name": "South Africa"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Sneakers",
              "itemListElement": [
                {
                  "@type": "OfferCatalog",
                  "name": "Nike Sneakers"
                },
                {
                  "@type": "OfferCatalog",
                  "name": "Adidas Sneakers"
                },
                {
                  "@type": "OfferCatalog",
                  "name": "Jordan Sneakers"
                },
                {
                  "@type": "OfferCatalog",
                  "name": "New Balance Sneakers"
                }
              ]
            }
          }
        `}</script>

        {/* ── FAQ Schema ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Where is SA Dropped based?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "SA Dropped is based in Durban, South Africa and ships nationwide."
                }
              },
              {
                "@type": "Question",
                "name": "How long does delivery take?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Most orders arrive within 2-4 business days depending on your location across South Africa."
                }
              },
              {
                "@type": "Question",
                "name": "How does the ordering process work?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Add your pair to cart, fill in your details at checkout, and our team will contact you to confirm and arrange payment and delivery. No online payment is taken upfront."
                }
              },
              {
                "@type": "Question",
                "name": "What payment methods do you accept?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We accept EFT and cash on collection for local Durban customers."
                }
              }
            ]
          }
        `}</script>
      </Helmet>

      <Navbar />
      <main>
        <Hero />
        <Editorial />
        <Stats />
        <FeaturedProducts />
        <Testimonials />
        <FAQ />
      </main>
    </>
  );
}